import { useStaticQuery, graphql } from 'gatsby';

export const useIsLitter = (): boolean => {
  const data = useStaticQuery(graphql`
    query {
      site {
        siteMetadata {
          isLitter
        }
      }
    }
  `);

  return data.site.siteMetadata.isLitter;
};
